/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkidentity_Link1Inputs */

const zh_linkidentity_link1 = /** @type {(inputs: Linkidentity_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定`)
};

const en_linkidentity_link1 = /** @type {(inputs: Linkidentity_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const es_linkidentity_link1 = /** @type {(inputs: Linkidentity_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Linkidentity_Link1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linkidentity_link1 = /** @type {((inputs?: Linkidentity_Link1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkidentity_Link1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linkidentity_link1(inputs)
	if (locale === "en") return en_linkidentity_link1(inputs)
	return es_linkidentity_link1(inputs)
});
export { linkidentity_link1 as "linkIdentity_link" }